<svg height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256.313 256.313" xml:space="preserve">
    <g class="tag-icon-group">
        <path [style]="'fill:' + color + ';stroke-width: 0.75rem;'" d="M163.854,250.072c-8.365,8.322-21.87,8.322-30.192,0L16.047,139.762
		c-6.576-6.168-14.414-17.856-14.979-26.853c-1.512-24.34-0.446-70.947,0.294-95.657C1.628,8.246,9.2,0.696,18.212,0.489
		c31.568-0.734,98.452-1.518,104.669,4.705l129.52,117.179c8.316,8.322,0.772,29.371-7.609,37.736L163.854,250.072z M60.789,36.284
		c-7.054-7.038-18.46-7.038-25.52,0c-7.038,7.06-7.038,18.46,0,25.498c7.065,7.044,18.471,7.044,25.52,0
		C67.833,54.744,67.833,43.338,60.789,36.284z" />
    </g>
</svg>